import { stegaClean } from '@sanity/client/stega';
import { GROQCTA } from '@/sanity/lib/definitions';
import { IPageLink, resolveCTA, resolvePageLink } from '@/sanity/globals/CTA';
import { IPopup } from '@/sanity/globals/Popups';

/**
 * Detecta automaticamente o tipo de tracking baseado no destino do CTA
 */
function detectTrackingAction(
  action: string | null | undefined,
  link: string | null | undefined,
  anchor: string | null | undefined,
  popup: IPopup | null,
): string {
  // Anchor para contact form
  if (anchor === '#contact-us' || anchor === '#contact') {
    return 'contact-form';
  }

  // Link interno para página de contato
  if (
    link &&
    (link === '/contact' ||
      link === '/kontakt' ||
      link.includes('/contact') ||
      link.includes('/kontakt'))
  ) {
    return 'contact-form';
  }

  // Popup (geralmente formulário)
  if (popup) {
    return 'popup-form';
  }

  // Links externos WhatsApp
  if (link && (link.includes('wa.me') || link.includes('whatsapp'))) {
    return 'whatsapp';
  }

  // Links externos gerais
  if (link && (link.startsWith('http://') || link.startsWith('https://'))) {
    return 'external-link';
  }

  // Links internos para services
  if (
    link &&
    (link.includes('/services') || link.includes('/dienstleistungen'))
  ) {
    return 'services';
  }

  // Links internos para blog
  if (link && link.includes('/blog')) {
    return 'blog';
  }

  // Default para links internos
  if (link) {
    return 'internal-link';
  }

  // Default quando não identificado
  return 'button-click';
}

export function useCTAWrapper(cta: GROQCTA | null | undefined) {
  const cleanedCta = (stegaClean(cta ?? null) ?? null) as GROQCTA | null;

  const action = cleanedCta?.action ?? null;
  const actionData = resolveCTA(cleanedCta ?? null);

  const isLink = action === 'link' && actionData;
  const link = isLink ? resolvePageLink(actionData as IPageLink | null) : null;
  const openInNewTab = isLink ? (actionData as IPageLink)?.openInNewTab : false;

  const isAnchor = action === 'anchor' && actionData;
  const anchor = isAnchor ? (actionData as string) : null;

  const isPopup = action === 'popup' && actionData;
  const popup = isPopup ? (actionData as IPopup) : null;

  // Detecta automaticamente o tipo de tracking
  const trackingAction = detectTrackingAction(action, link, anchor, popup);

  return {
    action,
    isLink,
    link,
    openInNewTab,
    isAnchor,
    anchor,
    isPopup,
    popup,
    trackingAction,
  };
}
